import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './AppIcon';

const BreadcrumbNavigation = () => {
  const location = useLocation();

  const routeLabels = {
    '/financial-dashboard-overview': 'Dashboard',
    '/client-management-system': 'Clientes',
    '/expense-management-system': 'Despesas',
    '/financial-reports-generator': 'Relatórios',
    '/cash-flow-forecasting': 'Fluxo de Caixa',
    '/authentication-and-role-selection': 'Autenticação'
  };

  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
  
  const breadcrumbs = pathSegments?.map((segment, index) => {
    const path = `/${pathSegments?.slice(0, index + 1)?.join('/')}`;
    return {
      label: routeLabels?.[path] || segment?.replace(/-/g, ' '),
      path: path,
      isLast: index === pathSegments?.length - 1
    };
  });

  if (breadcrumbs?.length === 0) {
    return null;
  }

  return (
    <div className="breadcrumb-container">
      <nav aria-label="Breadcrumb">
        <ol className="breadcrumb-list">
          <li className="breadcrumb-item">
            <Link to="/financial-dashboard-overview" className="breadcrumb-link">
              <Icon name="Home" size={16} />
            </Link>
          </li>
          {breadcrumbs?.map((crumb, index) => (
            <React.Fragment key={crumb?.path}>
              <li className="breadcrumb-item">
                <Icon name="ChevronRight" size={16} />
              </li>
              <li className="breadcrumb-item">
                {crumb?.isLast ? (
                  <span className="breadcrumb-current">{crumb?.label}</span>
                ) : (
                  <Link to={crumb?.path} className="breadcrumb-link">
                    {crumb?.label}
                  </Link>
                )}
              </li>
            </React.Fragment>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default BreadcrumbNavigation;